// frontend/src/app/claim-annotator/ports/claims-provider.port.ts
import { InjectionToken } from '@angular/core';
import { Claim } from '../domain/types';

export interface ClaimsProvider {
  loadFor(documentId: string): Promise<Claim[]>;
}

export const CLAIMS_PROVIDER = new InjectionToken<ClaimsProvider>('CLAIMS_PROVIDER');
